import React from "react";
import { message } from "antd";

export function showValidationErrors(errors) {
    if (!errors || errors.length === 0) return;

    message.error({
        content: (
            <div>
                <strong>Please fix the following:</strong>
                <ul style={{marginTop: 8, paddingLeft: 20}}>
                    {errors.map((msg, i) => (
                        <li key={i} style={{listStyleType: "disc"}}>{msg}</li>
                    ))}
                </ul>
            </div>
        ),
        duration: 2
    }).then(r => r.duration);
}